import { IconChevronDown } from '@tabler/icons-react';
import styles from './miniQuickActions.module.scss';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { ROUTER_GROUPS } from '@/core/constants/routes';
import { useDashboard } from '@/contexts/dashboard/dashboard.context';
import { useClevertap, useGtm } from '@/contexts/analytics/analytics.context';
import { renderCards } from '../../helper';
import { H6 } from '@/design-system/text/h6/h6';
import { BodyS } from '@/design-system/text/bodyS/bodyS';
import { CaptionM } from '@/design-system/text/caption-m/caption-m';

export default function QuickActions() {
  const { dashboardLabels } = useDashboard();
  const { quickActions } = dashboardLabels;
  const router = useRouter();
  const clevertap = useClevertap();
  const gtmModule = useGtm();

  const policyDefaultCards = renderCards(quickActions.noPolicyCards);

  return (
    <div className={styles['actions-main-con']}>
      <H6 text={quickActions.title} />
      <div className={styles['act-card-con']}>
        {policyDefaultCards.map((card, index) => (
          <div
            data-event-name={quickActions.actionsClevertapEvent?.name}
            onClick={() => {
              // if (card.key === 'ekycSelection') {
              //   router.push(ROUTER_GROUPS.kyc.kycSelection);
              // } else {
              if (card.key === 'ekycRegistration') {
                router.push(`${ROUTER_GROUPS.kyc.generate()}`);
              } else if (card.key === 'transferOfInsuranceMotor') {
                router.push(ROUTER_GROUPS.motor.transferInsurance);
              } else {
                router.push(
                  `${ROUTER_GROUPS.policy.policySelection}?action=${card.key}`
                );
                if (quickActions.actionsClevertapEvent?.name) {
                  clevertap?.sendButtonEvent(
                    quickActions.actionsClevertapEvent.name,
                    quickActions.actionsClevertapEvent.payload
                  );
                }
                gtmModule.dashboard().sendSelectPromotion({
                  id: 'quick actions',
                  name: card.title,
                });
                clevertap?.sendEventWithName('Quick Actions_Click', {
                  'Inception Point': 'Landing Page',
                  'Feature Name': card.title,
                });

                // }
              }
            }}
            key={index}
            className={styles['act-card']}
          >
            <div className={styles['act-img-con']}>
              <Image
                src={card.imageUrl}
                alt={quickActions.title}
                width={100}
                height={100}
                className={styles['action-image']}
              />
            </div>
            <BodyS text={card.title} maxLines={2} />
          </div>
        ))}
        <div
          data-event-name={quickActions.buttonTextClevertapEvent?.name}
          onClick={() => {
            router.push(ROUTER_GROUPS.general.quickActions);
            if (quickActions.buttonTextClevertapEvent?.name) {
              clevertap?.sendButtonEvent(
                quickActions.buttonTextClevertapEvent.name,
                quickActions.buttonTextClevertapEvent.payload
              );
            }
            gtmModule.dashboard().sendSelectPromotion({
              id: 'quick actions',
              name: quickActions.buttonText,
            });
          }}
          className={styles['act-btn-con']}
        >
          <CaptionM
            text={quickActions.buttonText}
            className={styles['btn-text']}
          />
          <IconChevronDown color="var( --tang-blue-600)" size={20} />
        </div>
      </div>
    </div>
  );
}
